import React from 'react';

const GalleryPage = () => {
  const galleryItems = [
    {
      id: 1,
      type: 'image',
      src: '/images/gallery-1.jpg'
    },
    {
      id: 2,
      type: 'video',
      src: '/videos/project-video-1.mp4',
      poster: '/images/video-thumb-1.jpg'
    },
    {
      id: 3,
      type: 'image',
      src: '/images/gallery-2.jpg'
    },
    {
      id: 4,
      type: 'image',
      src: '/images/gallery-3.jpg'
    },
    {
      id: 5,
      type: 'video',
      src: '/videos/project-video-2.mp4',
      poster: '/images/video-thumb-2.jpg'
    },
    {
      id: 6,
      type: 'image',
      src: '/images/gallery-4.jpg'
    },
    {
      id: 7,
      type: 'image',
      src: '/images/gallery-5.jpg'
    },
    {
      id: 8,
      type: 'video',
      src: '/videos/project-video-3.mp4',
      poster: '/images/video-thumb-3.jpg'
    },
    {
      id: 9,
      type: 'image',
      src: '/images/gallery-6.jpg'
    },
    {
      id: 10,
      type: 'image',
      src: '/images/gallery-7.jpg'
    },
    {
      id: 11,
      type: 'video',
      src: '/videos/project-video-4.mp4',
      poster: '/images/video-thumb-4.jpg'
    },
    {
      id: 12,
      type: 'image',
      src: '/images/gallery-8.jpg'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-slate-100">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
        
        .gallery-font {
          font-family: 'Inter', system-ui, sans-serif;
        }
        
        body, html {
          margin: 0;
          padding: 0;
          min-height: 100vh;
        }
      `}</style>
      
      <section className="py-20 gallery-font">
        <div className="container mx-auto px-6 lg:px-8 max-w-7xl">
          
          {/* Header Section */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center bg-gradient-to-r from-blue-100 to-purple-100 border-2 border-blue-200 rounded-full px-6 py-2 mb-6">
              <span className="text-blue-700 font-medium text-sm tracking-wide uppercase">Visual Documentation</span>
            </div>
            <h1 className="text-5xl font-bold bg-gradient-to-r from-slate-800 via-blue-700 to-purple-700 bg-clip-text text-transparent mb-6">
              Project Gallery
            </h1>
            <p className="text-slate-600 text-xl max-w-2xl mx-auto leading-relaxed">
              Professional documentation and visual records of our project achievements
            </p>
          </div>

          {/* Gallery Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {galleryItems.map((item) => (
              <div
                key={item.id}
                className="bg-white rounded-xl border-2 border-gray-200 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group hover:border-blue-300"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  {item.type === 'image' ? (
                    <img
                      src={item.src}
                      alt={`Gallery image ${item.id}`}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                  ) : (
                    <div className="relative w-full h-full">
                      <img
                        src={item.poster}
                        alt={`Video thumbnail ${item.id}`}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="w-16 h-16 bg-black/60 backdrop-blur-sm rounded-full flex items-center justify-center group-hover:bg-black/80 transition-colors duration-300">
                          <svg className="w-8 h-8 text-white ml-1" fill="white" viewBox="0 0 24 24">
                            <path d="M8 5v14l11-7z"/>
                          </svg>
                        </div>
                      </div>
                    </div>
                  )}
                  
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  
                  {item.type === 'image' && (
                    <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-2 group-hover:translate-y-0">
                      <div className="w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg hover:bg-white transition-colors">
                        <svg className="w-5 h-5 text-slate-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                      </div>
                    </div>
                  )}
                </div>
                <div className={`p-1 ${item.type === 'video' ? 'bg-gradient-to-r from-red-500 to-pink-500' : 'bg-gradient-to-r from-blue-500 to-purple-500'}`}></div>
              </div>
            ))}
          </div>

          {/* Bottom Section */}
          <div className="mt-16 text-center">
            <div className="bg-gradient-to-r from-slate-100 to-blue-50 border-2 border-slate-200 rounded-2xl p-10 shadow-lg">
              <h3 className="text-2xl font-bold text-slate-800 mb-4">
                Visual Excellence
              </h3>
              <p className="text-slate-600 text-lg max-w-3xl mx-auto leading-relaxed">
                Each image represents our commitment to quality and transparency in project execution and documentation standards.
              </p>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};

export default GalleryPage;